import { React, useEffect, useState} from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import User from "../bootstrap/User";
import { getAuthToken } from "../api/api";
import styled from "styled-components";
import CustomDetailsComponent from "../components/common/CustomDetailsComponent";
import { getAPIUrl, notify, suppressKeyboardEvent } from "../components/common/helpers";
import { getUserDetails } from "../components/sidebar/Sidenav";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { UserDetailsCellRenderer } from "../components/common/CustomCellRenderer";

const StyledUserDetails = styled.div`
  .btn:disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
  .Deletebtn {
    background: transparent;
    border: none;
    color: white;
  }
  .Deletebtn:hover {
    background: transparent;
    border: none;
  }
  .Deletebtn:disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
`;

export default function UserManagement(props) {
  const { disabledFeatures } = props;
  const [tableData, setTableData] = useState();
  const [edit, setEdit] = useState(false);
  const [recordValues, setRecordValues] = useState();
  const [readOnly, setReadOnly] = useState(false);
  const [gridEntries, setGridEntries] = useState();
  const [title, setTitle] = useState("");

  const controller = new AbortController();
  const handleEdit = (field) => {
    setEdit(true);
    setRecordValues(field);
  };

  const handleUserDetails = (field) => {
    setReadOnly(true);
    setGridEntries(field);
    setTitle(`Details of ${field.user_name} of User Id- ${field.user_id}`);
  }

  const handleDeleteUser = (field) => {
    const { user_details_id, user_name } = field;
    const msg = `Are you sure, you want to delete User ${user_name}`;
    const confirm = window.confirm(msg);
    if (confirm) {
      const body = JSON.stringify({
        user_details_id,
        title: "UserManagement",
        updated_by: getUserDetails().username,
      });

      axios({
        method: "PATCH",
        url: getAPIUrl("deleteFunctionApi"),
        headers: { Authorization: getAuthToken()},
        data: body
      })
      .then((res) => {
        if (res) {
          getUsers();
        }
      })
      .catch((error) => {
        console.log(error);
      }); 
    }
  };

  const column = [
    {
      headerName: "User Name",
      field: "user_name",
      floatingFilter: true,
    },
    {
      headerName: "User ID",
      field: "user_id",
      floatingFilter: true,
    },
    {
      headerName: "Role",
      field: "role_name",
      floatingFilter: true,
    },
    {
      headerName: "Details",
      field: "release_details_id",
      width: 100,
      colId: "details",
      minWidth: 100,
      cellRenderer: UserDetailsCellRenderer,
      cellRendererParams: {
       type : "info",
       handleUserDetails
      }
    },
    {
      headerName: "Action",
      field: "user_details_id",
      colId: "action",
      cellRenderer: UserDetailsCellRenderer,
      cellRendererParams: {
       type : "edit",
       disabledFeatures,
       handleEdit,
       handleDeleteUser
      }
    },
  ];
  const defaultColDef = {
    sortable: true,
    filter: true,
    flex: 1,
    resizable: true,
    minWidth: 110,
    suppressKeyboardEvent
  };

  const requiredKeys = {
    created_date: "Created Date", 
    created_by: "Created By",
    updated_by : "Updated By",
    updated_date : "Updated Date"
  }

  // calling getUsers function for first time
  useEffect(() => {
    document.title = "User Management";
    getUsers();

    return () => {
      controller.abort();
    };
  }, []);

  const getUsers = () => {
    axios
      .get(getAPIUrl("getUserDetailsApi"), 
      {
        headers: { Authorization: getAuthToken() },
        signal: controller.signal,
      })
      .then((resp) => {
        if (resp && resp.data.length > 0) {
          setTableData(resp.data);
        } else {
          setTableData([]);
        }
      })
      .catch((err) => {
        setTableData([]);
        err.message !== "canceled" && notify("fetching");
      });
  };

  return (
    <StyledUserDetails>
      <h4 className="text-white p-2">User Management</h4>
      <div
        className="container-fluid"
        style={{
          background: "#1F1F1F 0% 0% no-repeat padding-box",
          border: "1px solid #707070",
          width: "100%",
        }}
      >
        <div className="text-end py-2">
          <User disabledFeatures={disabledFeatures} getUsers={getUsers} />
        </div>
        <div className="text-end py-2">
            {readOnly && <CustomDetailsComponent 
            gridEntries= {gridEntries}
            readOnly = {readOnly}
            setReadOnly= {setReadOnly}
            requiredKeys= {requiredKeys}
            title ={title}/> }
        </div>
        <div
          className="ag-theme-alpine-dark"
          style={{ height: 545, width: "100%" }}
        >
          {edit && (
            <User
              disabledFeatures={disabledFeatures}
              getUsers={getUsers}
              isEdit={edit}
              setEdit={setEdit}
              rowEntries={recordValues}
            />
          )}
          <AgGridReact
            rowData={tableData}
            columnDefs={column}
            defaultColDef={defaultColDef}
            pagination={true}
            paginationAutoPageSize={true}
          ></AgGridReact>
        </div>
        <div className="py-2"></div>
      </div>
        <ToastContainer
        style={{ width: "50%" }}
        closeOnClick={false}
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        limit={1}
      />
    </StyledUserDetails>
  );
}